export default {
  "root": "_root_blget_1",
  "item": "_item_blget_1"
};import "ni:sha-256;ITiuZjgsQjSQNHeE4UCSiZS6KzrVdkT0oNbnAAkSt44";